module.exports = __webpack_public_path__ + "static/img/fishGame2.8eea33e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/fishGame2.png
// module id = Zi5e
// module chunks = 3